import React, { useState } from 'react';
import { requestPasswordResetTicket } from '../services/authService';
import '../styles/ForgotPasswordModal.css';

function ForgotPasswordModal({ isOpen, onClose }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!email) {
      setError('Lütfen e-posta adresinizi girin.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await requestPasswordResetTicket(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="forgot-modal-overlay">
      <div className="forgot-modal-content">
        <button className="forgot-modal-close" onClick={onClose}>×</button>

        <h3 className="forgot-modal-title">Şifremi Unuttum</h3>

        {!success ? (
          <>
            <p style={{ marginBottom: '15px', color: '#666', fontSize: '0.9rem' }}>
              Şifrenizi sıfırlamak için lütfen e-posta adresinizi girin. Yöneticilerimiz isteğinizi inceleyip size dönüş yapacaktır.
            </p>
            <input
              type="email"
              className="forgot-modal-input"
              placeholder="E-posta Adresiniz"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
            <button className="forgot-modal-button" onClick={handleSubmit} disabled={loading}>
              {loading ? 'Gönderiliyor...' : 'İstek Gönder'}
            </button>
            {error && <p className="forgot-modal-error">{error}</p>}
          </>
        ) : (
          <div className="success-message">
            <p style={{ color: 'green', fontSize: '1.1rem', textAlign: 'center', margin: '20px 0' }}>
              İsteğiniz gönderildi, ekip tarafından değerlendirilerek dönüş yapılacak.
            </p>
            <button className="forgot-modal-button" onClick={onClose}>
              Kapat
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ForgotPasswordModal;
